export default {
    basicBgColor: '#222326',
    basicColor: '#FFC304',
    basicErrorColor: '#F6465D',
    basicSuccessColor: '#0ECB81',
    basicWhite: '#FFFFFF'
};
